<template>
  <a-drawer width="60%" :visible="open" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form" :rules="rules">
      <a-form-model-item :label="$t('上门服务.服务名称')" prop="serviceName">
        <a-input v-model="form.serviceName" :maxLength="128" :placeholder="$t('通用.输入.请输入')+$t('上门服务.服务名称')" />
      </a-form-model-item>

      <a-form-model-item :label="$t('上门服务.服务简介')" prop="serviceIntro">
        <a-textarea v-model="form.serviceIntro" :rows="2" :maxLength="500" />
      </a-form-model-item>

      <a-row :gutter="24">
        <a-col :span="12">
          <a-form-model-item :label="$t('上门服务.服务主图')" prop="picture">
            <OssUploadSingle v-model="form.picture" type="img" :maxSize="200" prefix="service"></OssUploadSingle>
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item :label="$t('上门服务.服务分类')" prop="categoryId">
            <a-tree-select v-model="form.categoryId" style="width: 100%"
                           :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }" 
                           :tree-data="categoryOptions" 
                           :placeholder="$t('通用.输入.请选择')+$t('上门服务.服务分类')"
                           :replaceFields="{ children: 'children', title: 'categoryName', key: 'id', value: 'id' }"
                           tree-default-expand-all allow-clear>
            </a-tree-select>
          </a-form-model-item>
        </a-col>
      </a-row>

      <a-form-model-item :label="$t('上门服务.归属城市')" prop="cityIds">
        <a-select
          v-model="form.cityIds"
          mode="multiple"
          style="width: 100%"
          :placeholder="$t('上门服务.归属城市提示')"
          option-filter-prop="children"
          :filter-option="filterCityOption"
          allow-clear>
          <a-select-option v-for="city in cityOptions" :key="city.areaId" :value="String(city.areaId)">
            {{ city.areaName }}
          </a-select-option>
        </a-select>
        <div style="color: #999; font-size: 12px;">{{ $t('上门服务.归属城市提示') }}</div>
      </a-form-model-item>

      <a-form-model-item :label="$t('上门服务.服务轮播图')" prop="imgList">
        <OssUploadMulti v-if="open" v-model="form.imgList" :isArrayData="true" :max-count="5" prefix="service" type="img"></OssUploadMulti>
      </a-form-model-item>

      <a-row :gutter="24">
        <a-col :span="12">
          <a-form-model-item :label="$t('上门服务.服务价格')" prop="price">
            <a-input-number v-model="form.price" :min="0" :precision="2" style="width: 100%" />
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item :label="$t('上门服务.价格单位')" prop="priceUnit">
            <a-input v-model="form.priceUnit" :maxLength="50" placeholder="如：次、小时、天" />
          </a-form-model-item>
        </a-col>
      </a-row>

      <a-row :gutter="24">
        <a-col :span="6">
          <a-form-model-item :label="$t('上门服务.是否推荐')" prop="isRecommend">
            <a-radio-group v-model="form.isRecommend" button-style="solid">
              <a-radio-button v-for="(item, index) in customDict.TFEnum" :value="item.type" :key="index">
                {{ item.name }}
              </a-radio-button>
            </a-radio-group>
          </a-form-model-item>
        </a-col>
        <a-col :span="6">
          <a-form-model-item :label="$t('上门服务.是否热搜')" prop="isHot">
            <a-radio-group v-model="form.isHot" button-style="solid">
              <a-radio-button v-for="(item, index) in customDict.TFEnum" :value="item.type" :key="index">
                {{ item.name }}
              </a-radio-button>
            </a-radio-group>
          </a-form-model-item>
        </a-col>
        <a-col :span="6">
          <a-form-model-item :label="$t('上门服务.状态')" prop="status">
            <a-radio-group v-model="form.status" button-style="solid">
              <a-radio-button v-for="(item, index) in customDict.OnOffEnum" :value="item.type" :key="index">
                {{ item.name }}
              </a-radio-button>
            </a-radio-group>
          </a-form-model-item>
        </a-col>
        <a-col :span="6">
          <a-form-model-item :label="$t('上门服务.排序')" prop="sort">
            <a-input-number v-model="form.sort" :min="0" style="width: 100%" />
            <div style="color: #999">数字越大越靠前；排序相同时，后新增的服务靠前。</div>
          </a-form-model-item>
        </a-col>
      </a-row>

      <!-- 服务项目 -->
      <a-divider orientation="left">{{ $t('上门服务.服务项目') }}</a-divider>
      <div class="table-operations" style="margin-bottom: 16px">
        <a-button type="dashed" @click="addItem">
          <a-icon type="plus" />{{ $t('上门服务.添加项目') }}
        </a-button>
      </div>
      <a-table :data-source="form.itemList" :columns="itemColumns" rowKey="key" :pagination="false" bordered>
        <template slot="itemName" slot-scope="text, record">
          <a-input v-model="record.itemName" :maxLength="128" :placeholder="$t('通用.输入.请输入')+$t('上门服务.项目名称')" />
        </template>
        <template slot="price" slot-scope="text, record">
          <a-input-number v-model="record.price" :min="0" :precision="2" style="width: 100%" />
        </template>
        <template slot="sort" slot-scope="text, record">
          <a-input-number v-model="record.sort" :min="0" style="width: 100%" />
        </template>
        <template slot="action" slot-scope="text, record, index">
          <a @click="delItem(index)" style="color: red">{{ $t('通用.按钮.删除') }}</a>
        </template>
      </a-table>

      <a-divider />

      <a-form-model-item :label="$t('上门服务.服务详情')" prop="description">
        <editor v-model="form.description" :height="300" />
      </a-form-model-item>

      <a-form-model-item :label="$t('上门服务.备注')" prop="remark">
        <a-textarea v-model="form.remark" :rows="2" :maxLength="500" />
      </a-form-model-item>

      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">{{$t('通用.按钮.保存')}}</a-button>
          <a-button @click="onClose">{{$t('通用.按钮.取消')}}</a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getService, addService, updateService, listChinaCity } from '@/api/homeservice/service'
import { listCategory } from '@/api/homeservice/category'
import OssUploadSingle from '@/components/OssUploadSingle'
import OssUploadMulti from '@/components/OssUploadMulti'
import Editor from '@/components/Editor'
import { mapGetters } from 'vuex'

export default {
  name: 'CreateForm',
  components: { OssUploadSingle, OssUploadMulti, Editor },
  data() {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 18 },
      submitLoading: false,
      formTitle: '',
      open: false,
      formType: 1,
      categoryOptions: [],
      cityOptions: [],
      form: {
        id: null,
        serviceName: null,
        serviceIntro: null,
        picture: null,
        imgList: [],
        description: null,
        price: null,
        priceUnit: '次',
        categoryId: null,
        cityIds: [],
        isRecommend: false,
        isHot: false,
        status: 1,
        sort: 0,
        remark: null,
        itemList: []
      },
      itemColumns: [
        { title: this.$t('上门服务.项目名称'), dataIndex: 'itemName', scopedSlots: { customRender: 'itemName' }, width: '40%' },
        { title: this.$t('上门服务.项目价格'), dataIndex: 'price', scopedSlots: { customRender: 'price' }, width: '25%' },
        { title: this.$t('上门服务.排序'), dataIndex: 'sort', scopedSlots: { customRender: 'sort' }, width: '15%' },
        { title: this.$t('通用.文本.操作'), dataIndex: 'action', scopedSlots: { customRender: 'action' }, width: '20%' }
      ],
      rules: {
        serviceName: [{ required: true, message: this.$t('上门服务.服务名称') + this.$t('通用.文本.不能为空'), trigger: 'blur' }],
        picture: [{ required: true, message: this.$t('上门服务.服务主图') + this.$t('通用.文本.不能为空'), trigger: 'blur' }],
        categoryId: [{ required: true, message: this.$t('上门服务.服务分类') + this.$t('通用.文本.不能为空'), trigger: 'change' }],
        price: [{ required: true, message: this.$t('上门服务.服务价格') + this.$t('通用.文本.不能为空'), trigger: 'blur' }]
      }
    }
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  created() {
    this.getCategoryList()
    this.getCityList()
  },
  methods: {
    getCityList() {
      listChinaCity().then(response => {
        const list = response.data || []
        // 下拉城市按名称 A-Z（拼音）排序
        list.sort((a, b) => (a.areaName || '').localeCompare(b.areaName || '', 'zh-CN'))
        this.cityOptions = list
      })
    },
    // 城市下拉搜索过滤
    filterCityOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    getCategoryList() {
      listCategory({}).then(response => {
        const tree = this.handleTree(response.data, 'id', 'parentId')
        // 禁用有子节点的分类（一级分类），只允许选择叶子节点
        this.categoryOptions = this.disableBranchNodes(tree)
      })
    },
    // 递归禁用有子节点的分类
    disableBranchNodes(nodes) {
      if (!nodes || nodes.length === 0) return nodes
      return nodes.map(node => {
        const newNode = { ...node }
        if (node.children && node.children.length > 0) {
          // 有子节点，禁用选择
          newNode.disabled = true
          newNode.children = this.disableBranchNodes(node.children)
        }
        return newNode
      })
    },
    onClose() {
      this.open = false
      this.reset()
    },
    reset() {
      this.formType = 1
      this.form = {
        id: null,
        serviceName: null,
        serviceIntro: null,
        picture: null,
        imgList: [],
        description: null,
        price: null,
        priceUnit: '次',
        categoryId: null,
        cityIds: [],
        isRecommend: false,
        isHot: false,
        status: 1,
        sort: 0,
        remark: null,
        itemList: []
      }
    },
    handleAdd() {
      this.reset()
      this.formTitle = this.$t('通用.文本.添加')
      this.formType = 1
      this.open = true
    },
    handleUpdate(row) {
      this.reset()
      this.formType = 2
      this.formTitle = this.$t('通用.文本.修改')
      getService({ id: row.id }).then(response => {
        const data = response.data
        // 处理轮播图：后端返回数组格式
        let imgList = []
        if (data.imgList) {
          if (Array.isArray(data.imgList)) {
            imgList = data.imgList
          } else if (typeof data.imgList === 'string') {
            imgList = data.imgList.split(',').filter(url => url)
          }
        }
        // 处理归属城市：后端返回逗号分隔字符串，转为数组（空为全国）
        let cityIds = []
        if (data.cityIds && typeof data.cityIds === 'string') {
          cityIds = data.cityIds.split(',').filter(id => id)
        }
        // 按城市名称 A-Z（拼音）排序
        const cityNameMap = {}
        this.cityOptions.forEach(c => { cityNameMap[c.areaId] = c.areaName })
        cityIds.sort((a, b) => {
          const nameA = cityNameMap[a] || ''
          const nameB = cityNameMap[b] || ''
          return nameA.localeCompare(nameB, 'zh-CN')
        })
        this.form = {
          ...data,
          imgList: imgList,
          cityIds: cityIds,
          itemList: (data.itemList || []).map((item, index) => ({
            ...item,
            key: index + 1
          }))
        }
        // 先设置数据，再打开弹窗
        this.$nextTick(() => {
          this.open = true
        })
      })
    },
    addItem() {
      const key = this.form.itemList.length + 1
      this.form.itemList.push({
        key,
        id: null,
        itemName: '',
        price: null,
        sort: key
      })
    },
    delItem(index) {
      this.form.itemList.splice(index, 1)
    },
    submitForm() {
      this.$refs.form.validate(valid => {
        if (valid) {
          // 过滤有效服务项目（含名称且有价格）
          const validItemList = this.form.itemList.filter(item => item.itemName && item.price !== null)
          if (validItemList.length === 0) {
            this.$message.warning(this.$t('上门服务.服务项目至少一条'))
            return
          }
          this.submitLoading = true
          // 处理图片数组转字符串
          const submitData = {
            ...this.form,
            imgList: this.form.imgList && this.form.imgList.length > 0 ? this.form.imgList.join(',') : null,
            // 归属城市：数组转逗号分隔字符串，空数组传空字符串表示全国
            cityIds: this.form.cityIds && this.form.cityIds.length > 0 ? this.form.cityIds.join(',') : '',
            itemList: validItemList
          }

          const api = this.formType === 1 ? addService : updateService
          api(submitData).then(() => {
            this.$message.success(this.formType === 1 ? this.$t('通用.文本.新增成功') : this.$t('通用.文本.修改成功'))
            this.open = false
            this.$emit('ok')
          }).finally(() => {
            this.submitLoading = false
          })
        }
      })
    }
  }
}
</script>

<style scoped>
::v-deep .adaptive { height: auto; }
::v-deep .editor .w-e-text-container { height: 300px !important; }
</style>
